import React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $getSelection,
  $isRangeSelection,
  KEY_TAB_COMMAND,
  COMMAND_PRIORITY_LOW,
  INDENT_CONTENT_COMMAND,
  OUTDENT_CONTENT_COMMAND,
} from 'lexical';
import { $isListNode } from '@lexical/list';

// Tab Plugin to handle tab character insertion and list indentation
const TabPlugin = () => {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    return editor.registerCommand(
      KEY_TAB_COMMAND,
      (event) => {
        event.preventDefault();

        const selection = $getSelection();
        if (!$isRangeSelection(selection)) {
          return false;
        }

        // Check if we're inside a list
        const anchorNode = selection.anchor.getNode();
        const element =
          anchorNode.getKey() === 'root' ? anchorNode : anchorNode.getTopLevelElementOrThrow();
        const parent = element.getParent();

        // If we're in a list, use indent/outdent commands
        if ($isListNode(element) || $isListNode(parent)) {
          if (event.shiftKey) {
            // Shift+Tab: outdent
            editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, undefined);
          } else {
            // Tab: indent
            editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined);
          }
          return true;
        }

        // Otherwise, insert a tab character
        editor.update(() => {
          if ($isRangeSelection(selection)) {
            selection.insertText('\t');
          }
        });

        return true;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor]);

  return null;
};

export default TabPlugin;
